import Router from 'vue-router';

import ChoiceOfFlat from './pages/ChoiceOfFlat';
import DetailedChoiceOfFlat from './pages/DetailedChoiceOfFlat'
import SelectedFlat from './pages/SelectedFlat'

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },

  routes: [
    {
      path: '/choice-of-apartment',
      component: ChoiceOfFlat
    },
    {
      path: '/choice-of-apartment/details',
      component: DetailedChoiceOfFlat
    },
    {
      path: '/choice-of-apartment/selected/:number',
      component: SelectedFlat
    },
  ]
})

export default router
